export const moduleConfig = {
    entityKey: 'accounts',
    enableNameCompletenessCheck: false
}